export interface BlockSessionData{
    content: Array<object>|{[key: string]: object},
    title?: string;
    oti?: string;
}

export class BlockSession{
    protected static instance?: BlockSession;

    protected _session?: Storage;
    protected _islock: boolean = false;
    protected _sessionKey: string = 'BLK_DATA';
    protected _semaphoreKey: string = 'BLK_DATA_LOCK';

    public constructor(){
        try{
            // only define "session" if cookies have beeen accepted
            if(typeof Cookiebot !== 'undefined' && Cookiebot.consented){
                this._session = window?.sessionStorage??undefined;
                this._clearExpired();
            }
        }catch(e){}
    }
    /**
     * Return the session storage
     */
    public get session(): Storage|undefined{
        return this._session;
    }

    public get isLock(): boolean{
        if(this._islock){
            return true;
        }
        let v = this._session && this._session.getItem(this._semaphoreKey);
        return v ? true : false;
    }

    public set isLock(value: boolean){
        this._islock = value;
        if(this._session){
            if(this._islock){
                this._session.setItem(this._semaphoreKey, '1');
            }else{
                this._session.removeItem(this._semaphoreKey);
            }
        }
    }

    protected _loadSessionData(): any{
        let storeLang    = this._storeLang();
        let keyStoreLang = 'strlng'
        let data = this._session && !this._isCacheUpdate() ? this._session.getItem(this._sessionKey): undefined;
        if(data){
            try {
                let result = JSON.parse(data);
                let strlng = result.hasOwnProperty(keyStoreLang) ? result[keyStoreLang] : '-';
                if(strlng == storeLang){
                    return result;
                }
            }catch(e){}
        }
        return {[keyStoreLang]: storeLang};
    }

    protected _clearExpired(){
        this.isLock = true;
        let data    = this._loadSessionData();
        let final: {[key: string]: any} = {};
        Object.keys(data).forEach(key => {
            let expiry  = data[key]?.expiry ?? 0;
            let content = data[key]?.content ?? undefined;
            if(content && expiry > Date.now()){
                final[key] = data[key];
            }
        });
        this._saveSessionData(data);
        this.isLock = false;
    }

    protected _saveSessionData(data: any): any{
        if(this._session && data){
            this._session.setItem(this._sessionKey,JSON.stringify(data));
        }
    }

    protected _isCacheUpdate(){
        const url = window.location.href.toLowerCase();
        return url.indexOf('cache-update=99') > -1 || url.indexOf('/cache-update/99') > -1;
    }

    public setBlockData(blockData: BlockSessionData, key: string, params: string, ttl: number, validationKey?: string): void{
        if(this.isLock){
            setTimeout(() => {
                this.setBlockData(blockData, key, params, ttl);
            }, 10);
        }
        this.isLock = true;
        let data = this._loadSessionData();
        data[key] = {
            content: blockData.content,
            title: blockData.title,
            oti: blockData.oti,
            expiry: Date.now() + (ttl * 1000),
            params: params,
            validationKey: (validationKey??'')
        }
        this._saveSessionData(data);
        this.isLock = false;
    }    

    protected _storeLang(): string{
        let path = window.location?.pathname.split("/") ?? [];
        let store = path.length >=2 ? path[1] : 'ww';
        let lang  = path.length >=3 ? path[2] : 'en';
        let theme = this._webTheme();
        return store + '-' + lang + '-' + theme; 
    }

    protected _webTheme(): string{
        const value = `${document.cookie}`;
        const parts = /_am\=([^;]*)/g.exec(value);
        return parts && parts.length === 2 ? parts[1] : '';
    }

    public getBlockData(key: string, params: string, validationKey: string): any{
        const data    = this._loadSessionData();
        const details = data[key] ?? undefined;
        const expiry  = details?.expiry ?? 0;
        const dparams = details?.params ?? '-';
        const tmplId  = details?.validationKey ?? '-';
        if(expiry > Date.now() && params == dparams && tmplId == validationKey){
            return {
                content: details?.content ?? undefined,
                title: details?.title ?? undefined,
                oti: details?.oti ?? undefined,
            };
        }
        
        return undefined;
    }    

    public static getInstance(): BlockSession{
        if(!this.instance){
            this.instance = new BlockSession();
        }
        return this.instance;
    }
}